// responsible for all redirect landing page

import { RootState } from "app/store";
import { appInsights } from "global/Application/AppInsight";

import { Link, ProgressIndicator, Stack, Text } from "@fluentui/react";
import { trimGUIDLower } from "global/Utility/TSFunctions";
import * as IRedirects from 'model/Redirect.type';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { setWebResourceEmbedded } from "global/Reducer/statusSlice";
// at the moment entry point is mapped to router with 1~1,
// I think what makes sense is on landing, redirect to a redirect parse on a fresh start or stateless
// , queue actions(auth, initialize, ... redirect) and then route appropriately 
// do some 

interface IViewModel {
    badSession: boolean;
    redirecting: boolean;
    redirectUrl: string;
}

const Redirect = () => {
    const state = useSelector(state => state) as RootState;
    const history = useHistory();
    const dispatch = useDispatch();

    const [viewModel, setViewModel] = useState<IViewModel>({
        badSession: false,
        redirecting: false,
        redirectUrl: ''
    });

    useEffect(() => {
        document.title = "Redirect";
    }, []);

    useEffect(() => {

        let redirectTimeout: NodeJS.Timeout | null = null;
        const redirectRequest = state.router.location.query as IRedirects.TRedirectRequest;
        const crmRedirectRequest = state.router.location.query as IRedirects.IOpportunityProductRedirectRequest;

        console.log('redirect request', redirectRequest);

        appInsights?.trackEvent({
            name: 'Redirect.onMount',
            properties: { redirect: redirectRequest }
        });

        //expected payload

        if (redirectRequest.reason === "view-config" || redirectRequest.reason === "new-config") {

            const path = `/records/blueRelationship/${trimGUIDLower(redirectRequest.accountId)}/groupConfiguration/${trimGUIDLower(redirectRequest.snapshotId)}/`
            history.push({ pathname: path });
            setViewModel(viewModel => { return { ...viewModel, badSession: false, redirecting: true } });
        }
        else if (redirectRequest.reason === "view-multiple-config") {

            const path = `/records/blueRelationship/${trimGUIDLower(redirectRequest.accountId)}`;
            history.push({ pathname: path, search: state.router.location.search });
            setViewModel(viewModel => { return { ...viewModel, badSession: false, redirecting: true } });


        } else if (redirectRequest.reason === "external-redirect") {

            if (state.status.account) {

                // const redirectUrl = `${Constants.crm.baseUrl}/main.aspx?pagetype=entityrecord&etn=account&id=${state.status.account?.accountid}`;
                // redirectTimeout = setTimeout(() => {
                //     // making sure user is still on same redirect page, and has not backed out.
                //     window.location.href = redirectUrl;
                // }, 2000);

                // setViewModel(viewModel => { return { ...viewModel, badSession: false, redirecting: true, redirectUrl: redirectUrl } });
            }
            else {
                setViewModel(viewModel => { return { ...viewModel, badSession: true } });
                history.goBack();
            }


        } else if (crmRedirectRequest.id && crmRedirectRequest.typename === 'bcbs_opportunityproduct') {
            const path = `/bcbs_opportunityproduct/${trimGUIDLower(crmRedirectRequest.id)}`;
            dispatch(setWebResourceEmbedded(true));
            history.replace({
                pathname: path,
                search: state.router.location.search
            });
        }

        return () => {

            // clear timer
            if (redirectTimeout !== null)
                clearTimeout(redirectTimeout);
        }

    }, []);


    if (viewModel.badSession)
        return <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center', marginTop: '5%' }}>
            <Text variant="large">Session is no longer available.</Text>
        </div>

    if (viewModel.redirecting)
        return (
            <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center', marginTop: '5%' }}>
                <Stack tokens={{ childrenGap: '8' }} horizontalAlign={"center"} >
                    <Text variant="xxLargePlus" styles={{ root: { fontWeight: '180' } }}>Redirecting, Please wait...</Text>
                    <div style={{ width: '600px' }}>
                        <ProgressIndicator />
                    </div>
                    <span>
                        Click <Link href={`${viewModel.redirectUrl}`}>here</Link> if you are not automatically redirected.
                    </span>
                </Stack>
            </div>
        )

    return <div></div>;
}

export default Redirect;
